import { districtState } from '@/app/model/store/domain/types.ts'

export default {
  setDistrictList (state: districtState, payload: any) {
    state.districtData = payload
  },
  setSearchText (state: districtState, payload: string) {
    state.searchText = payload
  },
  setSortName (state: districtState, sortName: string) {
    state.sortName = sortName
  },
  setSortAsc (state: districtState, sort: boolean) {
    state.sortAsc = sort
  }
}
